import { SITE } from "@/lib/site";

export const FALLBACK_PROJECTS = [
  "Roofing inspections, repairs, and replacement",
  "Kitchen and bathroom remodeling",
  "Home additions and ADUs (where appropriate)",
  "Outdoor living — patios, decks, and pergolas",
  "Exterior repair, fascia, and trim work",
  "Investor and rental property repairs",
  "Ongoing residential maintenance memberships",
];

export function buildCityFaqs(cityName) {
  return [
    { q: `Does Black Ridge Construction serve ${cityName}, TX?`, a: `Yes. ${cityName} is part of our regular service area in Central Texas. We handle roofing, remodeling, additions, exterior work, repairs, and ongoing maintenance plans here.` },
    { q: `What construction services do you offer in ${cityName}?`, a: `Full-service general contracting — roofing, kitchen and bath remodels, home additions, ADUs and garage conversions where appropriate, outdoor living, exterior repair, drywall and paint, flooring, fence and gate work, and ongoing maintenance memberships.` },
    { q: `Do you provide roofing services in ${cityName}?`, a: `Yes. We schedule roof inspections, repair existing roofs, replace roofs when needed, and document storm-related damage. We do not guarantee insurance approvals.` },
    { q: `Can I get a home maintenance plan in ${cityName}?`, a: `Yes. Our HomeCare residential memberships and PropertyCare commercial plans are available throughout our Central Texas service area, including ${cityName}.` },
    { q: `Do you handle both small repairs and larger remodels in ${cityName}?`, a: `Yes. Black Ridge handles small repairs, punch list items, single-room remodels, full-home remodels, additions, and ongoing maintenance — in one relationship.` },
    { q: `How do I request a consultation in ${cityName}?`, a: `Submit the consultation form on this page, visit our contact page, or call us directly at ${SITE.phone}.` },
  ];
}
